module.exports = __webpack_public_path__ + "static/media/gg_titlebar_select_arrow_disabled.a7f1ec8d.svg";